const VAPID_PUBLIC_KEY = process.env.REACT_APP_WEBPUSH_PUBLIC_KEY || '';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export async function registerChatPush(chatAPI) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !VAPID_PUBLIC_KEY) {
    return null;
  }

  const registration = await navigator.serviceWorker.register('/chat-sw.js');
  const permission = await Notification.requestPermission();

  if (permission !== 'granted') {
    return null;
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  const payload = {
    endpoint: subscription.endpoint,
    public_key: subscription.toJSON().keys.p256dh,
    auth_token: subscription.toJSON().keys.auth,
    device: navigator.userAgent,
  };

  await chatAPI.registerPushSubscription(payload);

  return subscription;
}

export async function unregisterChatPush(chatAPI, subscription) {
  if (!subscription) return;
  await subscription.unsubscribe();
  await chatAPI.unregisterPushSubscription(subscription.endpoint);
}







